
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as detailsHxZGqHA2XMMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/details.vue?macro=true";
import { default as documentsTrAyOWKTemMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/documents.vue?macro=true";
import { default as _91participantId_93Dw4WSsrtfbMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/expert-opinion/[participantId].vue?macro=true";
import { default as indexNxXrVtvdoZMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/index.vue?macro=true";
import { default as participantsUxUG1JSIFHMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/participants.vue?macro=true";
import { default as _91id_93hsMfjwPsfiMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id].vue?macro=true";
import { default as indexHrLzyCY85kMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/[type]/index.vue?macro=true";
import { default as calendardl1uTsCzXmMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/calendar.vue?macro=true";
import { default as indexQGFzxa1hvyMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/index.vue?macro=true";
import { default as invoicesvi1TcfQhgZMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/invoices.vue?macro=true";
import { default as routePlannerWmEmtBLmHPMeta } from "/builds/1tool/kfv-puk-app/pages/dashboard/routePlanner.vue?macro=true";
import { default as _91id_93BhKbHh2RN2Meta } from "/builds/1tool/kfv-puk-app/pages/event-details/[id].vue?macro=true";
import { default as indexMU8Pj92LLGMeta } from "/builds/1tool/kfv-puk-app/pages/events-list/index.vue?macro=true";
import { default as indexLVi7mfVKb0Meta } from "/builds/1tool/kfv-puk-app/pages/events/index.vue?macro=true";
import { default as indexpXVjVa6FKaMeta } from "/builds/1tool/kfv-puk-app/pages/index.vue?macro=true";
import { default as indexzLV7LyQsJ5Meta } from "/builds/1tool/kfv-puk-app/pages/keyDates/index.vue?macro=true";
import { default as indexoDOH2DzQTiMeta } from "/builds/1tool/kfv-puk-app/pages/login/index.vue?macro=true";
import { default as magic_45linkIHgMEiBGCYMeta } from "/builds/1tool/kfv-puk-app/pages/login/magic-link.vue?macro=true";
import { default as _91id_93sY1cTpWroBMeta } from "/builds/1tool/kfv-puk-app/pages/project-details/[id].vue?macro=true";
import { default as indexmq0sGBNNRIMeta } from "/builds/1tool/kfv-puk-app/pages/projects/index.vue?macro=true";
import { default as index5y8jUDH8OVMeta } from "/builds/1tool/kfv-puk-app/pages/proposals/index.vue?macro=true";
import { default as indexfqPGyHHmpIMeta } from "/builds/1tool/kfv-puk-app/pages/report/index.vue?macro=true";
import { default as indexv0exEoncRHMeta } from "/builds/1tool/kfv-puk-app/pages/reports/index.vue?macro=true";
import { default as indexm4IRx5hfTGMeta } from "/builds/1tool/kfv-puk-app/pages/reviews/index.vue?macro=true";
import { default as indexw2Qy34LnYkMeta } from "/builds/1tool/kfv-puk-app/pages/route-planner-projects/index.vue?macro=true";
import { default as indexnjzcaCvEbdMeta } from "/builds/1tool/kfv-puk-app/pages/signings/index.vue?macro=true";
export default [
  {
    name: _91id_93hsMfjwPsfiMeta?.name,
    path: "/dashboard/:type()/:id()",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id].vue"),
    children: [
  {
    name: "dashboard-type-id-details",
    path: "details",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/details.vue")
  },
  {
    name: "dashboard-type-id-documents",
    path: "documents",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/documents.vue")
  },
  {
    name: "dashboard-type-id-expert-opinion-participantId",
    path: "expert-opinion/:participantId()",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/expert-opinion/[participantId].vue")
  },
  {
    name: "dashboard-type-id",
    path: "",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/index.vue")
  },
  {
    name: "dashboard-type-id-participants",
    path: "participants",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/[id]/participants.vue")
  }
]
  },
  {
    name: "dashboard-type",
    path: "/dashboard/:type()",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/[type]/index.vue")
  },
  {
    name: "dashboard-calendar",
    path: "/dashboard/calendar",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/calendar.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-invoices",
    path: "/dashboard/invoices",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/invoices.vue")
  },
  {
    name: "dashboard-routePlanner",
    path: "/dashboard/routePlanner",
    component: () => import("/builds/1tool/kfv-puk-app/pages/dashboard/routePlanner.vue")
  },
  {
    name: "event-details-id",
    path: "/event-details/:id()",
    component: () => import("/builds/1tool/kfv-puk-app/pages/event-details/[id].vue")
  },
  {
    name: "events-list",
    path: "/events-list",
    component: () => import("/builds/1tool/kfv-puk-app/pages/events-list/index.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/builds/1tool/kfv-puk-app/pages/events/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/kfv-puk-app/pages/index.vue")
  },
  {
    name: "keyDates",
    path: "/keyDates",
    component: () => import("/builds/1tool/kfv-puk-app/pages/keyDates/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/1tool/kfv-puk-app/pages/login/index.vue")
  },
  {
    name: "login-magic-link",
    path: "/login/magic-link",
    component: () => import("/builds/1tool/kfv-puk-app/pages/login/magic-link.vue")
  },
  {
    name: "project-details-id",
    path: "/project-details/:id()",
    component: () => import("/builds/1tool/kfv-puk-app/pages/project-details/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/builds/1tool/kfv-puk-app/pages/projects/index.vue")
  },
  {
    name: "proposals",
    path: "/proposals",
    component: () => import("/builds/1tool/kfv-puk-app/pages/proposals/index.vue")
  },
  {
    name: "report",
    path: "/report",
    component: () => import("/builds/1tool/kfv-puk-app/pages/report/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/builds/1tool/kfv-puk-app/pages/reports/index.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    component: () => import("/builds/1tool/kfv-puk-app/pages/reviews/index.vue")
  },
  {
    name: "route-planner-projects",
    path: "/route-planner-projects",
    component: () => import("/builds/1tool/kfv-puk-app/pages/route-planner-projects/index.vue")
  },
  {
    name: "signings",
    path: "/signings",
    component: () => import("/builds/1tool/kfv-puk-app/pages/signings/index.vue")
  }
]